/** @format */
import jQuery from "jquery";
import '@js/vendor/slick.min.js';
import ShopifyBuy from '@shopify/buy-button-js'

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[data-shop-block-id]').forEach(shopElement => {
        const collection = shopElement.dataset.shopifyCollection;
        const blockId = shopElement.dataset.shopifyBlockId;
        if (collection) {
            const client = ShopifyBuy.buildClient({
                domain: 'southbankcentreshop.myshopify.com',
                storefrontAccessToken: 'bc5d060c84bf7c98ac7f330320020b5a'
            });
            const ui = ShopifyBuy.UI.init(client);

            ui.createComponent('collection', {
                id: collection,
                node: shopElement.querySelector(`#${blockId}`),
                moneyFormat: '£{{amount}}',
                options: {
                    product: {
                        buttonDestination: 'onlineStore', // Set the button destination to the online store
                        layout: 'vertical',
                        iframe: false,
                        contents: {
                            img: true,
                            title: true,
                            price: true,
                            button: true,
                            options: false,
                        },
                        text: {
                            button: 'View Product'
                        }
                    },
                    productSet: {
                        iframe: false,
                        contents: {
                            pagination: false,
                        },
                        events: {
                            afterRender(component) {
                                // Remove loader
                                const loader = shopElement.querySelector(`.c-loader`);
                                if (loader) loader.style.display = 'none';

                                // Adjust the price formatting after products render
                                setTimeout(() => formatPrices(shopElement), 300);
                            }
                        }
                    },
                    cart: {
                        startOpen: false,
                    },
                }
            });

            if (document.body.classList.contains('single-event') || shopElement.closest('.c-col-shopify-block--carousel')) {
                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        if (mutation.addedNodes.length) {
                            Array.from(mutation.addedNodes).forEach(node => {
                                if (node.classList && node.classList.contains('shopify-buy__collection-products')) {
                                    const childObserver = new MutationObserver(childMutations => {
                                        childMutations.forEach(childMutation => {
                                            if (childMutation.addedNodes.length) {
                                                const allProductsLoaded = Array.from(node.childNodes).every(childNode => childNode.classList.contains('shopify-buy__product'));
                                                if (allProductsLoaded) {
                                                    renderCarousel();
                                                    childObserver.disconnect();
                                                }
                                            }
                                        });
                                    });

                                    childObserver.observe(node, {
                                        childList: true,
                                        subtree: true
                                    });
                                    observer.disconnect();
                                }
                            })

                        }
                    })
                })
                const target = document.getElementById(blockId);
                observer.observe(target, {
                    childList: true,
                    subtree: true,
                })
            }
        }

        function renderCarousel() {
            jQuery(`#${blockId} .shopify-buy__collection-products`).slick({
                dots: false,
                infinite: false,
                speed: 300,
                arrowsPlacement: 'afterSlides',
                slidesToShow: 3.1,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2.2,
                    }
                },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1.2,
                        }
                    }],
            });
        }

        function formatPrices(container) {
            var prices = container.querySelectorAll(`.shopify-buy__product__actual-price`);

            prices.forEach(priceElement => {
                let priceText = priceElement.innerText.trim().replace('£', ''); // Remove £ temporarily
                
                let priceFloat = parseFloat(priceText);
                if (!isNaN(priceFloat)) {
                    let formattedPrice = Number.isInteger(priceFloat) 
                        ? `£${priceFloat.toFixed(0)}`  // Remove decimals if whole number
                        : `£${priceFloat.toFixed(2)}`; // Keep decimals if necessary 
                    priceElement.innerText = formattedPrice;
                }
            });
        }
    });
});
